export default "__VITE_ASSET__sycq4Yqv__"